/** Cache scopes clearable from the CMS (POST /exercise-admin/cache/clear). */
export const CACHE_SCOPES = [
  {
    value: 'exercise-search',
    label: 'Exercise search',
    description: 'Search pages and library list caches (30 min TTL)',
  },
  {
    value: 'quick-log-activity-types',
    label: 'Quick Log activity types',
    description: 'Activity picker rows with localized names (6 h TTL)',
  },
  {
    value: 'equipment-catalog',
    label: 'Equipment catalog list',
    description: 'Equipment list/sheet cache (6 h TTL)',
  },
] as const;

export type CacheScopeValue = (typeof CACHE_SCOPES)[number]['value'];
